export const sofaTypes = [
  { text: 'Sectional', image: '/img/couch-intake/sectional.png' },
  { text: 'Sofa', image: '/img/couch-intake/sofa.png' },
  { text: 'Loveseat', image: '/img/couch-intake/loveseat.png' }
]
